import { useEffect, useState } from "react";
import {
  Box,
  Card,
  Chip,
  List,
  ListItem,
  ListItemText,
  Typography,
} from "@mui/material";
import { CheckCircle, RadioButtonUnchecked, CalendarToday, Checklist } from "@mui/icons-material";
import { Link } from "react-router-dom";
import moment from "moment";
import qs from "query-string";
import { getAllMesTaches } from "../../../Services/TacheCandidatService";
import { getUserData } from "../../../../utils/FunctionHelpers";
import Loader from "../../../../components/Loader/Loader";
import "./recentTasks.css";

moment.locale("fr");

const RecentTasks = () => {
  const [tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const uuid = getUserData()?.uuid;
    if (!uuid) {
      setLoading(false);
      return;
    }
    const searchParams = qs.stringify({ affecteA: uuid, dateFilter: "aujourduietpasse" });
    getAllMesTaches(searchParams)
      .then(({ data }) => {
        const sorted = [...(data?.TachesCandidat || [])].sort(
          (a, b) => new Date(b.createdAt.date) - new Date(a.createdAt.date)
        );
        setTasks(sorted.slice(0, 5));
      })
      .catch(() => setTasks([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <Card className="recentTasksCard" elevation={0}>
      <Box className="recentTasksHeader">
        <Box className="recentTasksHeaderLeft">
          <Checklist className="recentTasksHeaderIcon" />
          <Typography component="strong" className="recentTasksHeaderTitle">
            MES TÂCHES
          </Typography>
        </Box>
        <Link to="/tachescandidat" className="recentTasksViewAll">
          Voir tout →
        </Link>
      </Box>
      {loading ? (
        <Loader />
      ) : tasks.length === 0 ? (
        <Typography className="recentTasksEmpty">Aucune tâche à afficher.</Typography>
      ) : (
        <List>
          {tasks.map((task) => {
            const dueDate = moment(task.dateTime.date);
            const isOverdue = !task.statut && dueDate.isBefore(moment(), "day");

            return (
              <ListItem
                key={task.id}
                divider
                component={Link}
                to={{ pathname: `/candidats/${task.condidatId}/view` }}
                className="recentTasksItem"
              >
                {task.statut ? (
                  <CheckCircle className="recentTasksCheckDone" />
                ) : (
                  <RadioButtonUnchecked className="recentTasksCheckTodo" />
                )}
                <ListItemText
                  primary={
                    <span className={task.statut ? "recentTasksTitleDone" : "recentTasksTitle"}>{task.candidat}</span>
                  }
                  secondary={<span className="recentTasksSubtitle">{task.fonction || task.societe || ""}</span>}
                />
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "flex-end", gap: "6px", marginLeft: "12px" }}>
                  {!task.statut && <Chip label="À FAIRE" size="small" className="recentTasksBadgeTodo" />}
                  <Box className="recentTasksDateRow">
                    <CalendarToday
                      className="recentTasksDateIcon"
                      sx={{ color: isOverdue ? "#d03b3b" : "var(--profile-ink-secondary)" }}
                    />
                    <Typography
                      className="recentTasksDateText"
                      sx={{
                        color: isOverdue ? "#d03b3b" : "var(--profile-ink-secondary)",
                        fontWeight: isOverdue ? 600 : 400,
                      }}
                    >
                      {dueDate.format("DD/MM/YYYY")}
                    </Typography>
                  </Box>
                </Box>
              </ListItem>
            );
          })}
        </List>
      )}
    </Card>
  );
};

export default RecentTasks;
